export const getDocumentMask = (v) => {
  // Contém letras? ➜ máscara alfanumérica
  if (/[A-Za-z]/.test(v)) {
    return 'XX.XXX.XXX/XXXX-##'
  }

  // Só números ➜ mascara CPF ou CNPJ
  return ['###.###.###-##', '##.###.###/####-##']
}
